import CityPageTemplate from "../city-template/CityPageTemplate";
import { winchesterConfig } from "./data";

export default function WinchesterPage() {
  return <CityPageTemplate config={winchesterConfig} />;
}